<template>
    <ElDialog
        :modelValue="true"
        :appendToBody="true"
        :title="title"
        :width="width + 'px'"
        class="confirm-dialog"
        :showClose="false"
    >
        <template #header>
            <div
                class="confirm-dialog__header flex items-center justify-between"
            >
                <div class="confirm-dialog__title text-black">
                    {{ title }}
                </div>
                <div
                    class="confirm-dialog__close cursor-pointer"
                    @click="cancel"
                >
                    <SvgIcon
                        class="th-btn-icon h-6 w-6 !fill-gray-450"
                        icon="SolidCloseBig"
                    />
                </div>
            </div>
        </template>

        <template #default>
            <div class="confirm-dialog__body">
                <slot>
                    <div class="confirm-dialog__desc">
                        {{ desc }}
                    </div>
                </slot>
            </div>
        </template>

        <template #footer>
            <div class="confirm-dialog__footer flex items-center justify-end gap-2 pt-2">
                <div class="confirm-dialog__btn-cancel th-btn th-btn-secondary" @click="cancel">
                    {{ $t('aiDisclosureGlobal.globalBtn.cancel') }}
                </div>

                <div
                    class="confirm-dialog__btn-confirm th-btn"
                    :class="{'th-btn-disabled': disable}"
                    @click="confirm"
                >
                    <span
                        v-if="isLoadingSubmit"
                        class="th-loading th-loading-spinner th-loading-sm"
                    />

                    <span v-else>
                        {{ confirmText }}
                    </span>
                </div>
            </div>
        </template>
    </ElDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { ElDialog } from 'element-plus';
import '@patsnap-ui/icon/assets/solid/CloseBig.svg';
import SvgIcon from '@/presentation/components/common/svg-icon/SvgIcon.vue';

const props = withDefaults(defineProps<{
    title: string;
    confirmText?: string;
    desc?: string;
    disable?: boolean;
    isLoadingSubmit?: boolean;
    width?: number;
}>(), {
    desc: '',
    confirmText: '',
    disable: false,
    isLoadingSubmit: false,
    width: 600,
});

const emits = defineEmits<{
    (event: 'cancel'): void;
    (event: 'confirm'): void;
}>();

function cancel() {
    console.log('cancel');
    emits('cancel');
}

function confirm() {
    if (props.disable) return;
    emits('confirm');
}
</script>

<style lang="scss">
.confirm-dialog {
    overflow: hidden;
    box-shadow: 0 0 4px 0 #00000014, 0 2px 6px 0 #00000014;
    border-radius: 4px;

    &.el-dialog {
        overflow: hidden;
        display: flex;
        flex-direction: column;

        .el-dialog__body {
            overflow: auto;
            padding-top: 4px !important;
        }

        .el-dialog__header {
            margin-right: 0 !important;
        }
    }

    &__header {
        height: 56px !important;
        margin-top: -16px;
    }

    &__title {
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
    }
}

</style>
